export const CHAMPION_IMAGE_PATH = '/-/media/AIGWO/Backgrounds/wo-bg-champion-light.jpg';
export const FLAG_IMAGE_PATH = '/-/media/AIGWO/Icons/flag-green.png';
export const ACTION_POST_BASE_URL = '/-/media/AIGWO/feature/livetext/actionposts';
export const TEXTSAFE_SFV_IMAGE_PATH = '../dist/womensopen/images/text-safe-v2.png';
export const IS_HOLECARD_AVAILABLE = false;
export const LIVEPLAYER_BG_IMAGE_PATH = '/-/media/AIGWO/Backgrounds/wo-playercard-bg';
export const MULTIMEDIA_CAROUSEL_IMAGE_PATH = '/-/media/AIGWO/Backgrounds/multimedia-carousel-bg';
export const PLAYER_SILHOUETTE_ON_SCORECARD = '/-/media/AIGWO/AIGWO/Cut-Outs/Default/aigwo-no-pic-profile-pic';
export const PLAYOFF_ROUND_ID = 401;
